import { PayloadAction } from "@reduxjs/toolkit";

import { DriversState } from '../../types';

export const setSelectedDriverLocation = (
  state: DriversState,
  action: PayloadAction<DriversState['selectedLocation']>
) => {
  state.selectedLocation = action.payload;
}